// extracted by mini-css-extract-plugin
export default {"Footer":"footer_Footer__AKxJo","FooterrContent":"footer_FooterrContent__ucVb5","FooterLinks":"footer_FooterLinks__SBOKh"};